<template>
  <div>
    <div class="page-toolbar">
      <div class="page-title">品种管理</div>
      <div class="toolbar-actions">
        <el-button icon="el-icon-refresh" @click="loadVarieties">刷新</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="openCreateDialog">新增品种</el-button>
      </div>
    </div>

    <el-card class="page-card">
      <el-table :data="varieties" v-loading="loading" stripe>
        <el-table-column type="index" width="56" label="#" />
        <el-table-column prop="id" label="品种ID" min-width="220" show-overflow-tooltip />
        <el-table-column prop="name" label="品种名称" min-width="180" />
        <el-table-column prop="createdAt" label="创建时间" width="180" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="danger" @click="removeVariety(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="新增品种" :visible.sync="dialogVisible" width="420px" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="品种名称" prop="name">
          <el-input
            v-model.trim="form.name"
            maxlength="80"
            show-word-limit
            placeholder="请输入品种名称"
            @keyup.enter.native="submitForm"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createVariety, deleteVariety, fetchVarieties } from '../../api/admin'
import { isAuthRedirectError } from '../../utils/auth'

export default {
  name: 'VarietyListView',
  data() {
    return {
      loading: false,
      saving: false,
      dialogVisible: false,
      varieties: [],
      form: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入品种名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadVarieties()
  },
  methods: {
    async loadVarieties() {
      this.loading = true
      try {
        const list = await fetchVarieties()
        this.varieties = Array.isArray(list) ? list : []
      } catch (error) {
        if (isAuthRedirectError(error)) return
        this.$message.error(error.message || '品种列表获取失败')
      } finally {
        this.loading = false
      }
    },
    openCreateDialog() {
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    resetForm() {
      this.form = { name: '' }
      if (this.$refs.formRef) this.$refs.formRef.clearValidate()
    },
    submitForm() {
      if (!this.$refs.formRef) return
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.saving = true
        try {
          await createVariety({ name: this.form.name })
          this.$message.success('品种已创建')
          this.dialogVisible = false
          await this.loadVarieties()
        } catch (error) {
          if (isAuthRedirectError(error)) return
          this.$message.error(error.message || '品种创建失败')
        } finally {
          this.saving = false
        }
      })
    },
    removeVariety(row) {
      this.$confirm(`确认删除品种“${row.name || '-'}”吗？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteVariety(row.id)
          this.$message.success('删除成功')
          await this.loadVarieties()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar-actions {
  display: flex;
  gap: 10px;
}
</style>
